import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

const getAuthState = createSelector(
  [(state: RootState) => state.auth],
  (authState) => authState
);

export const getLogged = createSelector(
  [getAuthState],
  (auth) => !!auth.accessToken
);

export const getAccessToken = createSelector(
  [getAuthState],
  (auth) => auth.accessToken
);

export const getRefreshToken = createSelector(
  [getAuthState],
  (auth) => auth.refreshToken
);

export const getAccessExpiration = createSelector(
  [getAuthState],
  (auth) => auth.accessExpiresAt
);

export const getRefreshExpiration = createSelector(
  [getAuthState],
  (auth) => auth.refreshExpiresAt
);
